import React from "react";
// import flame from "../nohImg/flame.png";

const Vision = () => {
  return (
    <div className="bg-white">
      {/* English Mission Section */}
      <div className="px-6 xl:px-20 py-8 text-center">
        <div className="max-w-6xl mx-auto mt-8 mb-8">
          {/* Icon */}
          {/* <div className="flex justify-center mb-4">
            <img
              src={flame}
              alt="Fire alarm Icon"
              className="w-12 h-12 object-contain"
            />
          </div> */}

          {/* Mission Content */}
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-4xl font-semibold text-gray-900 mb-6">
              Mission
            </h2>

            <p className="text-gray-600 text-md md:text-lg leading-relaxed text-justify">
              Nohmi Bosai continues to strive to give customers an assurance of
              "safety" by providing optimum fire protection systems and a wide
              variety of services. To this end, the company, as a pioneer in the
              fire protection industry, is always aggressively challenging new
              fields of fire technologies, which include the following:
            </p>

            <div className="border-t border-gray-400 w-full my-6"></div>

            <div className="text-justify text-gray-700 text-md md:text-lg space-y-1">
              <p className="flex items-start gap-2">
                <span>■</span>
                <span>Intelligent fire protection systems that can be flexibly adapted for diversified urban spaces and industrial facilities.</span>
              </p>

              {/* <p className="flex items-start gap-2">
                <span>■</span>
                <span>Residential fire protection and emergency alarm systems that provide safer living.</span>
              </p> */}

              <p className="flex items-start gap-2">
                <span>■</span>
                <span>Survey of properties to be protected, analysis of their fire risks, and proposals for optimum fire protection systems.</span>
              </p>

              {/* <p className="flex items-start gap-2">
                <span>■</span>
                <span>Consistent responsibility setup for all works ranging from basic research, development, manufacturing, planning, installation, and maintenance.</span>
              </p> */}
            </div>

          </div>
        </div>
      </div>

      {/* Japanese Mission Section */}
      {/* <div className="px-6 py-10 flex justify-center">
        <div className="bg-gray-100 rounded-xl p-6 md:p-12 max-w-3xl text-center">
          <h2 className="text-2xl md:text-3xl font-serif text-gray-900 mb-4">
            ミッション（Mission）
          </h2>

          <p className="text-gray-800 text-md leading-relaxed text-justify">
            能美防災は、最適な防災システムや各種サービスをとおして出来るだけ多くの皆様に「安心」を提供していきたい、と考えています。
          </p>

          <p className="text-gray-800 text-md leading-relaxed text-justify mt-3">
            そのため、防災のパイオニアとして、たえず新しいフィールドへ意欲的にチャレンジしています。
          </p>

          <div className="text-gray-800 text-md leading-relaxed space-y-2 text-left mt-6">
            <p>■ 多様化した都市空間や産業施設に柔軟に対応できるインテリジェント防災システム</p>
            <p>■ より安全な暮らしをお約束できる一般住宅防災システムや集合住宅システム</p>
            <p>■ 防災対象の調査・診断と最適防災システムのご提案</p>
            <p>■ 基礎研究からシステム開発・機器製造・設計施工・メンテナンスまでの一貫した責任体制</p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Vision;
